import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './studentprofile.css';

function StudentProfile() {
  const navigate = useNavigate();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    if (!userData) {
      navigate('/login');
      return;
    }
    
    try {
      const parsed = JSON.parse(userData);
      setStudent(parsed.student);
      setLoading(false);
    } catch (error) {
      console.error('Error parsing userData:', error);
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('userData');
    localStorage.removeItem('student');
    localStorage.removeItem('token');
    navigate('/login');
  };

  if (loading) {
    return <div className="profile-loading">Loading profile...</div>;
  }

  if (!student) {
    return null;
  }

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-avatar">
          {student.name?.charAt(0).toUpperCase() || 'S'}
        </div>
        <h1>{student.name}</h1>
        <p className="profile-email">{student.email}</p>
      </div>

      <div className="profile-content">
        <div className="profile-section">
          <h2>Account Details</h2>
          <div className="profile-info-grid">
            <div className="profile-info-item">
              <span className="label">Level</span>
              <span className="value">{student.level || 'Beginner'}</span>
            </div>
            <div className="profile-info-item">
              <span className="label">Language</span>
              <span className="value">{student.language_preference || 'English'}</span>
            </div>
            {student.academic_year && (
              <div className="profile-info-item">
                <span className="label">Academic Year</span>
                <span className="value">{student.academic_year}</span>
              </div>
            )}
          </div>
        </div>

        {student.accessible_subjects && student.accessible_subjects.length > 0 && (
          <div className="profile-section">
            <h2>My Subjects</h2>
            <div className="subjects-grid">
              {student.accessible_subjects.map(subject => (
                <div key={subject.subject_id} className="subject-card">
                  <h3>{subject.subject_name}</h3>
                  <div className="features-list">
                    {subject.features?.map(feature => (
                      <span key={feature} className="feature-badge">
                        {feature.replace('_', ' ')}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="profile-actions">
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default StudentProfile;